import { Input, Typography } from 'antd';
import { RoundedCard } from 'components';
import styled from 'styled-components';

const { Text } = Typography;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
`;

export const Card = styled(RoundedCard)`
  width: 50%;

  .ant-card-body {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

export const SubTitle = styled(Text)`
  margin-bottom: 1rem;
`;

export const OtpInputField = styled(Input)`
  width: 85%;
`;

export const InvalidTextMsg = styled(Text)`
  align-self: flex-start;
  margin-left: 2.5rem;
`;

export const ResendCaptchaSection = styled.div`
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
